import angular from 'angular';

(function() {
    'use strict';

    angular.module('blocks.logger', ['toastr', 'pascalprecht.translate']);
})();
